// Angular
import { Component, Input, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { NextJsSyncGuard } from '../../../../../core/guards/next-js-sync.guard';
import { Router } from '@angular/router';


@Component({
  selector: 'kt-user-profile4',
  templateUrl: './user-profile4.component.html',
})
export class UserProfile4Component implements OnInit {
  // Public properties
  user$: Observable<User>;
  user: User;
  projectId:number;

  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;

  /**
   * Component constructor
   *
   * @param store: Store<AppState>
   */
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private nextJsSyncGuard: NextJsSyncGuard) {
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    this.user$ = this.store.pipe(select(currentUser));
    const userString = localStorage.getItem('currentUser');
    this.user = (JSON.parse(userString) as User);
    this.projectId = +localStorage.getItem('selectedProject');
  }

  /**
   * Log out
   */
  logout() {
    this.store.dispatch(new Logout());
  }

  // Add this method to your Angular component (header, navigation, or profile)
syncWithNextJs(targetRoute: string) {
    // First save sync data
    this.nextJsSyncGuard.saveSyncData().subscribe(
      response => {
        if (response && response.statusCode === 200) {
          // Then open Next.js window with the target route
          this.nextJsSyncGuard.syncWithNextJs(targetRoute);
        } else {
          console.error('Sync data not saved');
        }
      },
      error => {
        console.error('Failed to sync data:', error);
      }
    );
  }

}
